class MarketRoutes {
  static PROPERTY_DETAILS(id: number | string) {
    return `/property/${id}/view/property-details`;
  }

  static readonly MARKET = '/market/:id';
  static readonly MARKET_TRADE = '/market-new/:id/trade';
}

export default MarketRoutes;
